<script setup>
import { ref, defineProps } from 'vue';
import { useQuarterlyCommon } from './useQuarterlyCommon';
import { useCommonData } from '@/hooks';

defineProps({
	quarterDetails: {
		type: Object,
		default: () => ({})
	}
});

const { getOrganizationName, getStockInfoVOS } = useCommonData();
const organizationName = ref('');
const code = ref('');
setTimeout(() => {
	organizationName.value = getOrganizationName.value;
	code.value = getStockInfoVOS.value?.[0].code;
}, 500);

// 使用useQuarterlyCommon中的方法
const { core_option, percentCore } = useQuarterlyCommon();

// 重写handleCoreValue以保持特定的字体样式
const handleCoreValue = (val, key) => {
	if (percentCore.includes(key)) {
		return val.toFixed(2) + '%';
	} else {
		const { convertNumberToCNUnit } = require('@/utils/api.js');
		const { value, unit } = convertNumberToCNUnit(val);
		return unit ? `${value}<span style="font-size:20px">${unit}</span>` : value;
	}
};

const changeCore = val => {
	return core_option.value[val];
};
</script>

<template>
	<div class="quarter-flex-1 quarter-overview">
		<div class="color-fill"></div>
		<div class="color-mixin"></div>
		<div class="overview-content">
			<div class="quarter-title">{{ organizationName }}（{{ code }}）{{ quarterDetails.announcementTitle }}</div>
			<div class="quarter-info mt-48">
				<div class="quarter-info-item" v-for="(value, key) in quarterDetails.coreIndicators" :key="key">
					<div class="quarter-info-title">{{ changeCore(key) }}</div>
					<div class="quarter-info-data" v-html="handleCoreValue(value, key)"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="less" scoped>
.quarter {
	&-flex-1 {
		flex: 1;

		& + .quarter-flex-1 {
			margin-left: 96px;
		}
	}
	&-overview {
		position: relative;
		min-height: 254px;
		.color-fill {
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			background: var(--theme-color);
			opacity: 0.9;
		}
		.color-mixin {
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			background: url('~@/assets/images/home/quarter_overview_bg.png'),
				lightgray -49px -0.189px / 108.877% 102.118% no-repeat;
			mix-blend-mode: color-burn;
		}
		.overview-content {
			padding: 0 34px;
			display: flex;
			flex-direction: column;
			justify-content: center;
			position: relative;
			height: 100%;
		}
	}
	&-title {
		color: #fff;

		font-size: 24px;

		font-weight: 600;
		line-height: 140%; /* 33.6px */
		text-align: center;
	}
	&-info {
		display: flex;
		justify-content: space-between;
		&-item {
			flex: 1;
		}
		&-title {
			color: #fff;

			font-size: 14px;

			font-weight: 400;
			line-height: 16px; /* 114.286% */
		}
		&-data {
			margin-top: 4px;
			color: #fff;
			font-family: Barlow;
			font-size: 32px;

			font-weight: 500;
			line-height: 140%; /* 44.8px */
		}
	}
}
</style>
